import styled from 'styled-components';

export const StyledWrapper = styled.div`
	margin-top: 25px;
`;
